<template>
  <div class="container text-left">
    <div class="row mt-4">
      <div class="col">
        <button
          v-if="usableOrganizationTypes.length > 1"
          class="btn btn-link"
          data-toggle="modal"
          data-target="#createOrganizationModal"
        >
          Add Organization
        </button>
        <button
          class="btn btn-link"
          data-toggle="modal"
          data-target="#createUserModal"
        >
          Add User
        </button>
        <div class="container">
          <div
            v-for="orgType in organizationTypes.filter(
              ot =>
                myOrganizations.filter(
                  o => o.Organization_Type_Id == ot.Organization_Type_Id
                ).length > 0
            )"
            :key="orgType.Organization_Type_Id"
            class="row mt-4"
          >
            <div class="col">
              <p class="text-secondary">{{ orgType.Name }}s</p>
              <div class="container">
                <div
                  v-for="organization in myOrganizations.filter(
                    o => o.Organization_Type_Id == orgType.Organization_Type_Id
                  )"
                  :key="organization.Organization_Id"
                  class="row"
                >
                  <div class="col-auto px-0">
                    <i
                      class="material-icons pointer"
                      v-bind:id="organization.Organization_Id + 'toggleIcon'"
                      data-toggle="collapse"
                      v-bind:href="
                        '#organizationDetails' + organization.Organization_Id
                      "
                      role="button"
                      aria-expanded="false"
                      v-on:click="
                        $updateToggleIcon(
                          '#' + organization.Organization_Id + 'toggleIcon'
                        )
                      "
                      >add</i
                    >
                  </div>
                  <div class="col">
                    <h5
                      class="pointer btn-link"
                      v-on:click="editOrganization(organization)"
                    >
                      {{ organization.Name }}
                    </h5>
                    <div
                      class="container ml-4 collapse"
                      v-bind:id="
                        'organizationDetails' + organization.Organization_Id
                      "
                    >
                      <div class="row">
                        <div class="col">
                          <p class="text-secondary">
                            Name
                          </p>
                        </div>
                        <div class="col">
                          <p class="text-secondary">
                            Email
                          </p>
                        </div>
                        <div class="col">
                          <p class="text-secondary">
                            Phone
                          </p>
                        </div>
                      </div>
                      <div
                        class="row"
                        v-for="user in organization.Users"
                        :key="user.User_Id"
                      >
                        <div class="col">
                          <p
                            class="mb-1 pointer btn-link"
                            v-on:click="editUser(user)"
                          >
                            {{ user.First_Name }} {{ user.Last_Name }}
                          </p>
                        </div>
                        <div class="col">
                          <p class="mb-1">
                            {{ user.Email }}
                          </p>
                        </div>
                        <div class="col">
                          <p class="mb-1">
                            {{ user.Phone }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CreateUserModal
      v-bind:Organizations="myOrganizations"
      v-bind:AccountId="$store.getters.user.Account_Id.toString()"
      @addedUser="userAdded"
    />
    <CreateOrganizationModal
      v-bind:OrgTypes="usableOrganizationTypes"
      v-bind:OrgParents="myOrganizations"
      v-bind:AccountId="$store.getters.user.Account_Id.toString()"
      v-bind:Organization="organizationToEdit"
      @addedOrg="orgAdded"
      @editedOrg="orgEdited"
      @editClosed="editOrgClosed"
      @deletedOrg="orgDeleted"
    />
    <EditAccountUserModal
      v-if="myOrganizations != undefined"
      v-bind:UserToEdit="userToEdit"
      v-bind:Organizations="myOrganizations"
      @editedUser="userEdited"
    />
  </div>
</template>

<script>
import CreateUserModal from "@/modals/ManageAccounts/CreateUserModal.vue";
import CreateOrganizationModal from "@/modals/ManageAccounts/CreateOrganizationModal.vue";
import EditAccountUserModal from "@/modals/ManageAccounts/EditAccountUserModal";
import $ from "jquery";

export default {
  name: "Home",
  data() {
    return {
      organizationTypes: [],
      userToEdit: null,
      organizationToEdit: null,
      myOrganizations: [],
      usableOrganizationTypes: []
    };
  },
  components: {
    CreateUserModal,
    CreateOrganizationModal,
    EditAccountUserModal
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    try {
      view.$data.myOrganizations = await view.getMyOrganizations();
      view.$data.organizationTypes = await view.$getOrganizationTypes();
      view.$data.usableOrganizationTypes = await view.$getUsableOrganizationTypes(
        view.$data.organizationTypes,
        view.$data.myOrganizations.map(o => o.Organization_Type_Id)
      );
      view.$store.commit("updateLoading", false);
    } catch (err) {
      console.log(err);
      view.$store.commit("updateLoading", false);
    }
  },
  methods: {
    async getMyOrganizations() {
      var myOrganization = await this.$getOrganization(
        this.$store.getters.user.Organization_Id
      );
      var myOrgs = myOrganization.Child_Organizations;
      myOrgs.push(myOrganization);
      return myOrgs;
    },
    editOrganization(organization) {
      this.organizationToEdit = organization;
      $("#createOrganizationModal").modal("show");
    },
    orgAdded(newOrg) {
      this.myOrganizations.push(newOrg);
    },
    orgEdited(editedOrg) {
      var editingIndex = this.myOrganizations.findIndex(
        o => o.Organization_Id == editedOrg.Organization_Id
      );
      this.$set(this.myOrganizations, editingIndex, editedOrg);
    },
    orgDeleted(orgId) {
      var deletedIndex = this.myOrganizations.findIndex(
        o => o.Organization_Id == orgId
      );
      this.myOrganizations.splice(deletedIndex, 1);
    },
    editOrgClosed() {
      this.organizationToEdit = null;
    },
    userAdded(newUser) {
      var newUserName = newUser.First_Name + " " + newUser.Last_Name;

      this.$showSnackbar(
        "A user account was created and an email was sent to " + newUserName,
        false
      );
    },
    userEdited(editedUser) {
      var oldOrgIndex = this.myOrganizations.findIndex(o =>
        o.Users.map(u => u.User_Id).includes(editedUser.User_Id)
      );
      var oldUserIndex = this.myOrganizations[oldOrgIndex].Users.findIndex(
        u => u.User_Id == editedUser.User_Id
      );
      this.myOrganizations[oldOrgIndex].Users.splice(oldUserIndex, 1);

      var editingOrgIndex = this.myOrganizations.findIndex(
        o => o.Organization_Id == editedUser.Organization_Id
      );
      this.myOrganizations[editingOrgIndex].Users.push(editedUser);
    },
    editUser(user) {
      this.userToEdit = user;
      $("#editAccountUserModal").modal("show");
    }
  }
};
</script>

<style></style>
